import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const EDIT_EXCLUSION_ZONE_SCHEMA = z.enum(['Exclusion zone successfully edited.']);

export type EditExclusionZoneSchema = z.infer<typeof EDIT_EXCLUSION_ZONE_SCHEMA>;

export interface EditExclusionZonePromiseParam {
  display_id: string;
  zones: Array<Array<Array<number>>>;
}

export const editExclusionZonePromise = async (param: EditExclusionZonePromiseParam) => {
  try {
    const headers = getHeadersWithBearerToken();

    const formData = new FormData();
    formData.append('payload', JSON.stringify(param));

    const response = await ky.post(`${ENV.API_URL}/api/edit_exclusion_zone/`, { headers, body: formData }).json();

    const result = EDIT_EXCLUSION_ZONE_SCHEMA.safeParse(response);

    if (!result.success) {
      throw new Error('Invalid response');
    }

    return true;
  } catch (error) {
    console.error('Error editing exclusion zone:', error);
    return false;
  }
};
